// extracted by mini-css-extract-plugin
export default {"tableheader":"TableHeader_tableheader__e8Sxn"};